import React from "react";
import { makeStyles } from "@material-ui/core";
import { getFullName } from "../../utils/user.utils";
import { dispatch } from "../../events";
import { types } from "../../events/message";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'initial',
        '&:hover': {
            cursor: 'pointer'
        }
    }
}));

const UserName = ({ user, strong = false }) => {
    const classes = useStyles();

    const withStrong = () => (
        <strong>
            {getFullName(user)}
        </strong>
    );

    const withoutStrong = () => (
        <>
            {getFullName(user)}
        </>
    );

    const onClick = (event) => {
        event.stopPropagation();
        navigator.clipboard.writeText(user.id)
            .then(() => {
                dispatch(types.SET_MESSAGE, "User id copied to clipboard");
            });
    }
    return (
        <div className={classes.root} onClick={onClick}>
            {strong ? withStrong() : withoutStrong()}
        </div>
    );
}

export default UserName;